export const START_DATE_QUESTION_ASAP = 'ASAP';
export const CHOOSE_START_DATE_QUESTION_NAME = 'chooseStartDate';
export const TAKE_OVER_METER_CONNECTION_OLD_INHABITANT = 'TakeOverMeterConnectionOldInhabitant';
export const NEW_METER_CONNECTION = 'NewMeterConnection';
export const MOVE_TO_ENECO = 'MoveToEneco';
